import './BuyerNotes.less';
import { CommonNotes } from '../../common';
import { JobItem } from 'domains/workspaceDomain';

const BuyerNotes = (jobDate: JobItem) => {
  return (
    <div className="buyer-notes-card">
      <CommonNotes {...jobDate} />
    </div>
  );
};

export default BuyerNotes;
